import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GET_SINGLE_MOTORVOGN_SUCCESS,
  getSingleMotorvognByQuery as getSingleMotorvognByQueryAction,
} from "../../actions/motorvognActions";
import InnsynMotorvognUtskrift from "./InnsynMotorvognUtskrift";

export default function InnsynMotorvognUtskriftPage() {
  const dispatch = useDispatch();
  const motorvogn = useSelector((state) => state.innsynMotorvogn);

  const getSingleMotorvognByQuery = useCallback(
    (params) =>
      dispatch(
        getSingleMotorvognByQueryAction(params, GET_SINGLE_MOTORVOGN_SUCCESS),
      ),
    [dispatch],
  );

  return (
    <InnsynMotorvognUtskrift
      motorvogn={motorvogn}
      getSingleMotorvognByQuery={getSingleMotorvognByQuery}
    />
  );
}
